<template>
    <div class="uk-width-1-1 schedule-main-div">

  <!--
  <div style="width: 100%; background: rgb(76, 100, 100);" v-if="!Array.isArray(multi_channel_schedule_data['1']) && channel !== '-1'">
    <h1 class="search-results-channel-separator" >CHANNEL 12.{{channel}}</h1>
  </div>
  <span v-if="!Array.isArray(multi_channel_schedule_data['1']) && schedule_data != null && schedule_data.length == 0 && channel !== '-1'">No results.</span>


  <ul v-if="!Array.isArray(multi_channel_schedule_data['1'])" uk-accordion class="ul-search_results">
      <SearchAccordionLine v-for="air_data in schedule_data" v-bind:key="air_data.fulldate" v-bind:air_data="air_data" v-bind:channel="`12.${channel}`" />
  </ul>
  -->
        <span v-if="Object.keys(multi_channel_schedule_data).length > 0">
            <!-- span v-if="multi_channel_schedule_data['1'].length == 0 && multi_channel_schedule_data['2'].length == 0 && multi_channel_schedule_data['3'].length == 0 && multi_channel_schedule_data['4'].length == 0">No results.</span -->

            <div class="uk-visible@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: 167;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['1'].length > 0" class="search-results-channel-separator">CHANNEL 12.1</h1>
            </div>
            <div class="uk-visible@xs uk-hidden@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: 88;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['1'].length > 0" class="search-results-channel-separator">CHANNEL 12.1</h1>
            </div>
            <div v-if="multi_channel_schedule_data['1'].length > 0" style="width: 100%;border:0;padding:0;background: #f8f5ec" id="channel-12-1-separator">
                <SearchAccordionLine v-bind:schedule_data="multi_channel_schedule_data['1']" v-bind:channel="12.1"/>
            </div>
            <!--
            <span v-if="multi_channel_schedule_data != null && multi_channel_schedule_data['1'].length == 0">No results.</span>
            -->
            <div class="uk-visible@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: 167;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['2'].length > 0" class="search-results-channel-separator">CHANNEL 12.2</h1>
            </div>
            <div class="uk-visible@xs uk-hidden@s"  style="width: 100%;background: #4c6464;" uk-sticky="offset: 88;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['2'].length > 0" class="search-results-channel-separator">CHANNEL 12.2</h1>
            </div>
            <div v-if="multi_channel_schedule_data['2'].length > 0" style="width: 100%;border:0;padding:0;background: #f8f5ec"  id="channel-12-2-separator">
                <SearchAccordionLine v-bind:schedule_data="multi_channel_schedule_data['2']" v-bind:channel="12.2"/>
            </div>
            <!--
            <span v-if="multi_channel_schedule_data != null && multi_channel_schedule_data['2'].length == 0">No results.</span>
            -->

            <div class="uk-visible@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: 167;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['3'].length > 0" class="search-results-channel-separator">CHANNEL 12.3</h1>
            </div>
            <div class="uk-visible@xs uk-hidden@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: 88;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['3'].length > 0" class="search-results-channel-separator">CHANNEL 12.3</h1>
            </div>
            <div v-if="multi_channel_schedule_data['3'].length > 0" style="width: 100%;border:0;padding:0;background: #f8f5ec"  id="channel-12-3-separator">
                <SearchAccordionLine v-bind:schedule_data="multi_channel_schedule_data['3']" v-bind:channel="12.3"/>
            </div>
            <!--
            <span v-if="multi_channel_schedule_data != null && multi_channel_schedule_data['3'].length == 0">No results.</span>
            -->

            <div class="uk-visible@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: 167;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['4'].length > 0" class="search-results-channel-separator">CHANNEL 12.4</h1>
            </div>
            <div class="uk-visible@xs uk-hidden@s" style="width: 100%;background: #4c6464;" uk-sticky="offset: c;bottom: #bottom_app_div">
              <h1 v-if="multi_channel_schedule_data['4'].length > 0" class="search-results-channel-separator">CHANNEL 12.4</h1>
            </div>
            <div v-if="multi_channel_schedule_data['4'].length > 0" style="width: 100%;border:0;padding:0;background: #f8f5ec"  id="channel-12-4-separator">
                <SearchAccordionLine v-bind:schedule_data="multi_channel_schedule_data['4']" v-bind:channel="12.4"/>
            </div>
            <!--
            <span v-if="multi_channel_schedule_data != null && multi_channel_schedule_data['4'].length == 0">No results.</span>
            -->
        </span>
    </div>
</template>

<script>
import SearchAccordionLine from "./SearchAccordionLine"
import $ from 'jquery'
export default {
    components: {SearchAccordionLine},
    props:['schedule_data','multi_channel_schedule_data','channel'],
    name: "SearchResultsSchedule",
    data(){
      return {
          base_url: 'https://www.pbs12.org/',
      }
    },
    mounted(){
      setTimeout(() => {
        $('.pbs-search-grid-title').each( (n,acc) => {if(n == 0){console.log(n);$(acc).click()}})
      },500)
    },
    methods:{
    }
}
</script>

<style scoped>

    .ul-search_results{
      padding-bottom: 5px;
      margin-bottom: 0px
    }
    @media screen and (min-width:1180px) {
      .ul-search_results{
        margin-left: -35px;
      }
    }
    .pd-program-info{
        margin-top: 20px;
    }
    .uk-accordion-title:hover{
      /*background: #fff9c7;*/
      background-color: white;
    }
    .pbs-schedule-grid-time {
        color: black !important;
    }
    .pbs-schedule-grid-details {
        /*background-color: #f8f5ec;*/
        background-color: white;
        max-width: 1230px;
        margin-left: auto;
        margin-right: auto;
    }
    .uk-open{
        /*background-color: #f8f5ec;*/
        background-color: white;
    }
    .uk-accordion > :nth-child(n+2) {
        margin-top: 0px;
    }
    .uk-accordion{
      background-color: #f9eeca;
    }

    li:hover{
      background-color: white;
    }
</style>